// @ts-nocheck
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index.js";
import "./config";
import "@/style/overwrite.scss";
Vue.config.productionTip = false;

import PrometheusMonitor from "prometheus-monitor";
// css
import "prometheus-monitor/dist/prometheus-monitor.css";

Vue.use(PrometheusMonitor, {
  baseUrl: "/gavial/v1/metrics/prom/api/v1" // 请求默认 url
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

import pageTrun from "./components/pageTrun.vue";
import scrollPage from "./components/scroll.vue";
import ColorPicker from "@/components/ColorPicker.vue";

Vue.component("page-trun", pageTrun);
Vue.component("scroll", scrollPage);
Vue.component("colorPicker", ColorPicker);
